import React from "react";

import { SAMPLE_PATIENT } from "./sampleData";

/**
 * "What can this patient have today?" — the outcome the clinic's notes asked for.
 *
 * A plan record answers "what does the policy allow"; this answers the question
 * actually asked at the chair: the plan's frequencies crossed with the dates in
 * the practice's own history. Faked in the mock.
 *
 * Deliberately RECARE ONLY. Perio units used and maximum drawn down were both
 * cut: they need paid-claim history we do not hold, and a dollar figure we
 * cannot compute is worse here than no figure — a wrong "remaining" is the one
 * number staff would quote to a patient.
 */
export default function AvailableTodayCard({ patient }) {
  const p = patient || SAMPLE_PATIENT;
  return (
    <div className="bw-card">
      <p className="bw-card-title">
        Available today
        <span className="bw-count">{p.name}</span>
      </p>

      <div>
        {(p.recare || []).map(function (row) {
          return (
            <div className="bw-today-row" key={row.label}>
              <span className="bw-today-label">{row.label}</span>
              <span className={row.status === "due" ? "bw-due" : "bw-notdue"}>
                {row.status === "due" ? "eligible now" : row.detail}
              </span>
            </div>
          );
        })}
        <div className="bw-today-row">
          <span className="bw-today-label">Next appointment</span>
          <span className="bw-today-detail">{p.nextAppointment}</span>
        </div>
      </div>
    </div>
  );
}
